var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7641 11.4344C13.8822 9.55198 13.599 8.60745 13.599 5.59999C13.599 2.50718 11.0924 0 8.00008 0C4.9078 0 2.40115 2.50721 2.40115 5.59999C2.40115 7.22158 2.35796 7.82692 2.13474 8.57011C1.85715 9.49598 1.28728 10.3824 0.23581 11.4344C-0.267908 11.9384 0.088904 12.8 0.801434 12.8H5.24061L5.20033 13.2C5.20033 14.7464 6.45367 16 7.99979 16C9.54592 16 10.7993 14.7464 10.7993 13.2L10.759 12.8H15.1984C15.9112 12.8 16.2681 11.9384 15.7641 11.4344ZM8.00033 15.2C6.89605 15.2 6.00061 14.3043 6.00061 13.2L6.04089 12.8H9.95929L10.0001 13.2C10.0001 14.3043 9.10461 15.2 8.00033 15.2ZM0.801684 12C3.20115 9.59998 3.20115 7.99998 3.20115 5.59999C3.20115 2.94934 5.34968 0.799998 8.00008 0.799998C10.6505 0.799998 12.799 2.94934 12.7993 5.59999C12.7993 7.99998 12.7993 9.59998 15.1987 12H0.801684Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.fc3e3e2b.svg";
export { ForwardRef as ReactComponent };